var elementPosition = $('.list-group.list-group-flush').offset();
var elementHeight = $('.list-group.list-group-flush').height();
var spaceBottom = $(window).height() - elementHeight;

var windowWidth = $(window).width();




$(window).scroll(function(){
  var scrollBottom = $(document).height() - $(window).scrollTop();

  if (windowWidth > 780)
  {
    if($(window).scrollTop() > elementPosition.top && scrollBottom > 990 && elementHeight > 330)
    {
      $('.list-group.list-group-flush').css('position','fixed').css('top','0').css('bottom','');
    }
    else if($(window).scrollTop() > elementPosition.top && scrollBottom > 665 && elementHeight <= 330)
    {
      $('.list-group.list-group-flush').css('position','fixed').css('top','0').css('bottom','');
    }
    else if ($(window).scrollTop() > elementPosition.top && scrollBottom <= 990 && elementHeight > 330)
    {
      $('.list-group.list-group-flush').css('position','fixed').css('top','').css('bottom',1075 - scrollBottom + spaceBottom + 'px');
    }
    else if ($(window).scrollTop() > elementPosition.top && scrollBottom <= 665 && elementHeight <= 330)
    {
      $('.list-group.list-group-flush').css('position','fixed').css('top','').css('bottom',650 - scrollBottom + spaceBottom + 'px');
    }
    else {
      $('.list-group.list-group-flush').css('position','static');
    }
  }

});
